import { useSelector } from 'react-redux';
import { SharedStoreState } from 'types';

export const selectUserTeamAccess = (state: SharedStoreState) =>
	state.userTeamAccess;
export const useSelectUserTeamAccess = () => useSelector(selectUserTeamAccess);
